import { useSelector } from 'react-redux';
import { getBaccaratTimeout, getBaccaratUntilTime } from '../selectors';

export const useUntilTime = () => ({
  untilTime: useSelector(getBaccaratUntilTime),
  timeout: useSelector(getBaccaratTimeout),
});
